import { Dispatch } from "redux";
import {
    ChangeCaseNoAction,
    ChangeClearingDateAction,
    ChangeDateTimeAction,
    ChangeDisclaimerAction,
    ChangeDistrictAction,
    ChangeEmailAction,
    ChangeEnquiryTypeAction,
    ChangeExcelEndDateAction,
    ChangeExcelStartDateAction,
    ChangeFileListAction,
    ChangeGetBackDateAction,
    ChangeHandleDateAction,
    ChangeHaveVoiceMessageRadioAction,
    ChangeIsInpectedAction,
    ChangeIsOthersAction,
    ChangeIsOverfilledAction,
    ChangeMissCallRadioAction,
    ChangeNameAction,
    ChangeReplyDateAction,
    ChangeResultAction,
    ChangeTelAction,
    ChangeVoiceMessageTextAction,
    ChnageNeedInspectionAction,
    ClearEnquiryFormAction,
    EnquiryFormInfoAction,
    InitEnquiryListAction,
    InitSelectedEnquiryDataAction,
    OthersRemarkAction,
    SelectBinAction,
} from "./action";
import { BinInfo, DistrictList } from "../staticInfo/state";
import { SingleValue } from "react-select";
import { EnquiryFormList } from "./state";

export function ChangeIsOverfilledThunk(is_overfilled: boolean) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeIsOverfilledAction(is_overfilled));
    };
}

export function ChangeIsOthersThunk(is_others: boolean) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeIsOthersAction(is_others));
    };
}

export function ChangeDistrictThunk(
    district_id: string,
    district_list: DistrictList[]
) {
    const district = district_list.find(
        (district) => district.district_id === parseInt(district_id)
    );

    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(
            ChangeDistrictAction(district_id, district!.area_id.toString())
        );
    };
}

export function UploadPhotoThunk(fileList: File[]) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeFileListAction(fileList));
    };
}

export function ChangeDateTimeThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeDateTimeAction(date));
    };
}

export function SelectEnquiryTypeThunk(enquiry_type_id: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeEnquiryTypeAction(enquiry_type_id));
    };
}

export function ChanegCaseNoThunk(case_no: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeCaseNoAction(case_no));
    };
}

export function SelectBinThunk(binInfo: SingleValue<BinInfo>) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(SelectBinAction(binInfo));
    };
}

export function ChangeOtherRemarkThunk(remark: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(OthersRemarkAction(remark));
    };
}

export function InitEnquiryListThunk(enquiryList: EnquiryFormList[]) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(InitEnquiryListAction(enquiryList));
    };
}

export function ChnageNeedInspectionThunk(need_inspection: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChnageNeedInspectionAction(need_inspection));
    };
}

export function InitSelectedEnquiryData(EnquiryList: EnquiryFormList) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(InitSelectedEnquiryDataAction(EnquiryList));
    };
}

export function ChangeMissCallRadioThunk(have_missed_call: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeMissCallRadioAction(have_missed_call));
    };
}

export function ChangeHaveVoiceMessageThunk(have_voice_message: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeHaveVoiceMessageRadioAction(have_voice_message));
    };
}

export function ChangeVoiceMessageThunk(voice_message: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeVoiceMessageTextAction(voice_message));
    };
}

export function ChangeGetBackDateThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeGetBackDateAction(date));
    };
}

export function ChangeIsInspectedThunk(is_inspected: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeIsInpectedAction(is_inspected));
    };
}

export function ChangeHandleDateThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeHandleDateAction(date));
    };
}

export function ChangeClearDateThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeClearingDateAction(date));
    };
}

export function ChangeReplyDateThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeReplyDateAction(date));
    };
}

export function ChangeResultThunk(result: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeResultAction(result));
    };
}

export function ChangeNameThunk(name: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeNameAction(name));
    };
}

export function ChangeEmailThunk(email: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeEmailAction(email));
    };
}

export function ChangeTelThunk(tel: string) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeTelAction(tel));
    };
}

export function ClearEnquiryDataThunk(){
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ClearEnquiryFormAction());
    };
}

export function ChangeDisclaimerFromSurveyThunk(status:boolean){
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeDisclaimerAction(status));
    };
}

export function ChangeExcelStartDateThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeExcelStartDateAction(date));
    };
}


export function ChangeExcelEndDateThunk(date: Date) {
    return (dispatch: Dispatch<EnquiryFormInfoAction>) => {
        dispatch(ChangeExcelEndDateAction(date));
    };
}

